import { CommonModule } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import type { InnogyComponentRendering } from '@core/jss-models';
import { GenericRichTextDirective, getFieldValue } from '@core/jss-utils';
import { CrntButton } from '@essent/current-web-angular';
import {
  hasSelectedProductFormControlId,
  type OrderCrossSellFormValues,
} from '@innogy/become-a-customer/state';
import { CommonUiProductsModule } from '@innogy/common-ui/products';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { EuroCurrencyPipe } from '@innogy/utils-deprecated';
import type { StoreProductData } from '@legacy/common-ui-models';
import { ModalBodyDirective, ModalComponent } from '@legacy/common-ui-shared';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { SetValueAction, type FormGroupState } from 'ngrx-forms';

@Component({
  selector: 'wl-cross-sell-product-info-modal',
  templateUrl: './cross-sell-product-info-modal.component.html',
  standalone: true,
  imports: [
    AutomationIdDirective,
    CommonModule,
    CommonUiProductsModule,
    GenericRichTextDirective,
    ModalComponent,
    EuroCurrencyPipe,
    ModalBodyDirective,
    CrntButton,
  ],
})
export class CrossSellProductInfoModalComponent {
  private readonly store = inject(Store);
  private readonly activeModal = inject(NgbActiveModal);

  readonly rendering = signal<InnogyComponentRendering | undefined>(undefined);
  readonly product = signal<StoreProductData | undefined>(undefined);
  readonly formState = signal<
    FormGroupState<OrderCrossSellFormValues> | undefined
  >(undefined);

  readonly usps = computed(() => this.product()?.content.usps ?? []);
  readonly content = computed(() => ({
    perMonthLong: getFieldValue(this.rendering(), 'CrossSellMonthlyLong', ''),
    addProduct: getFieldValue(this.rendering(), 'CrossSellAddLabel', ''),
    rejectProduct: getFieldValue(this.rendering(), 'CrossSellRejectLabel', ''),
  }));

  public closeModal() {
    this.activeModal.close();
  }

  public selectProduct() {
    this.store.dispatch(
      new SetValueAction(hasSelectedProductFormControlId, true)
    );
    this.closeModal();
  }

  public rejectProduct() {
    this.store.dispatch(
      new SetValueAction(hasSelectedProductFormControlId, false)
    );
    this.closeModal();
  }
}
